import PropTypes from 'prop-types'
import { PageHeader } from 'sections/pageHeader/pageHeader'
import { HeaderBlock } from 'pages/landing/headerBlock'
import { FeaturesBlock } from 'pages/landings/featuresBlock'
import styles from './headerSection.module.scss'

const HeaderSection = ({ deals, defaultClass }) => {
  const showBackgroundImage = new Date() < new Date('2022-01-03T00:00:00.000-00:00')
  const imageClassname = showBackgroundImage ? `${styles.backgroundImage}` : null

  return (
    <PageHeader
      className={`${styles.formHeaderSection} ${imageClassname}`}
      darkRibbon
      contentRibbon={<FeaturesBlock />}
      formClassName={styles.pageHeaderForm}
      defaultClass={defaultClass}
    >
      <HeaderBlock hasImage={showBackgroundImage} {...deals} currency={'$'} />
    </PageHeader>
  )
}

HeaderSection.propTypes = {
  deals: PropTypes.object,
  defaultClass: PropTypes.string,
}

export { HeaderSection }
